import { cognitoLogin } from "../services/cognito";
import { getElementById } from "../services/dom";
import loginTemplate from "../templates/pages/login.html?raw";
import { Page } from "./base";

export default class LoginPage extends Page {
  private loginForm: HTMLFormElement;
  constructor() {
    super(loginTemplate)
    this.loginForm = getElementById("loginForm") as HTMLFormElement;
    this.loadPage();
  }

  private loadPage(): void {
    this.loginForm.addEventListener("submit", () => this.submitLoginForm());
    this.checkRegistrationSuccess();
    super.handleCustomAttributes();
  }

  private checkRegistrationSuccess(): void {
    // Check if user was redirected from registration
    const urlParams = new URLSearchParams(window.location.search);
    const registeredStatus = urlParams.get("registered");

    if (registeredStatus) {
      const messageSection = getElementById("section-message");
      if (messageSection) {
        if (registeredStatus === "success") {
          const successMessage = document.createElement("div");
          successMessage.className = "bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4 text-sm mx-12";
          successMessage.innerHTML = `
            <strong>Registration successful!</strong>
            <p class="mt-1">You will need to verify your email before logging in.</p>
          `;
          messageSection.appendChild(successMessage);
        } else if (registeredStatus === "error") {
          const errorMessage = document.createElement("div");
          errorMessage.className = "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm mx-12";
          errorMessage.innerHTML = `
            <strong>Registration failed</strong>
            <p class="mt-1">An unexpected error occurred when registering. Please try again.</p>
          `;
          messageSection.appendChild(errorMessage);
        }
      }

      // Clean up URL without reloading the page
      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    }
  }

  private async submitLoginForm() {
    const formData = new FormData(this.loginForm);
    const username = formData.get("username") as string;
    const password = formData.get("password") as string;

    // Clear any previous error messages
    this.clearErrorMessages();

    try {
      await cognitoLogin(username, password);
      window.location.href = "/";
    } catch (error: any) {
      console.error("Login error:", error);
      this.displayLoginError(error);
    }
  }

  private clearErrorMessages(): void {
    const messageSection = getElementById("section-message");
    if (messageSection) {
      // Remove all error messages
      const errorMessages = messageSection.querySelectorAll(".bg-red-100, .bg-yellow-100");
      errorMessages.forEach((msg) => msg.remove());
    }
  }

  private displayLoginError(error: any): void {
    const messageSection = getElementById("section-message");
    if (!messageSection) return;

    const errorDiv = document.createElement("div");
    let errorTitle = "Login failed";
    let errorMessage = "An unexpected error occurred. Please try again.";

    // Check for specific Cognito error types
    if (error.name === "UserNotConfirmedException") {
      errorDiv.className = "bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded mb-4 text-sm mx-12";
      errorTitle = "Email not verified";
      errorMessage = "Please confirm your email before logging in.";
    } else if (error.name === "NotAuthorizedException") {
      errorDiv.className = "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm mx-12";
      errorTitle = "Invalid credentials";
      errorMessage = "Incorrect username or password.";
    } else if (error.name === "UserNotFoundException") {
      errorDiv.className = "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm mx-12";
      errorTitle = "User not found";
      errorMessage = "No account found with this email address.";
    } else {
      errorDiv.className = "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4 text-sm mx-12";
    }

    errorDiv.innerHTML = `
      <strong>${errorTitle}</strong>
      <p class="mt-1">${errorMessage}</p>
    `;
    messageSection.appendChild(errorDiv);
  }
}
